module.exports = __webpack_public_path__ + "img/virado_header_5.adc410dd.jpg";